module.exports = __webpack_public_path__ + "assets/img/fenpei.24a77f9a.png";